// enci.vdr.js
'use strict';

class VdrManager {
  constructor() {
    this.storagePrefix = 'vdr_';
  }

  getStorageKey(key) {
    const route = window.location.pathname;
    return `${this.storagePrefix}${route}_${key}`;
  }

  async getState(key) {
    console.log('getState', key);
    const storageKey = this.getStorageKey(key);
    try {
      const value = localStorage.getItem(storageKey);
      if (value === null) return null;
      return JSON.parse(value);
    } catch (error) {
      console.error(`Error getting VDR state for ${key}:`, error);
      return null;
    }
  }

  async setState(key, value) {
    console.log('setState', key, value);
    const storageKey = this.getStorageKey(key);
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
      console.debug(`VDR state saved for ${key}:`, value);
    } catch (error) {
      console.error(`Error setting VDR state for ${key}:`, error);
    }
  }

  async clearState(key) {
    console.log('clearState', key);
    try {
      localStorage.removeItem(this.storagePrefix + key);
      console.debug(`VDR state cleared for ${key}`);
    } catch (error) {
      console.error(`Error clearing VDR state for ${key}:`, error);
    }
  }

  async clearAllStates() {
    console.log('clearAllStates');
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(this.storagePrefix)) {
          localStorage.removeItem(key);
        }
      });
      console.debug('All VDR states cleared');
    } catch (error) {
      console.error('Error clearing all VDR states:', error);
    }
  }
}

// Create instance
const vdrManager = new VdrManager();

// Export functions that will be called from C#
export const getState = async key => vdrManager.getState(key);
export const setState = async (key, value) => vdrManager.setState(key, value);
export const clearState = async key => vdrManager.clearState(key);
export const clearAllStates = async () => vdrManager.clearAllStates();

// Export the manager instance
export { vdrManager };
